import { Subscription } from "rxjs";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";

import swal from "bootstrap-sweetalert";

import { ProfileService } from "app/services/profile.service";
import { NewPasswordComponent, PasswordChangeData } from "../../account/asset/newPassword/newPassword-form.component";

@Component({
  selector: 'app-user-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  @ViewChild('newPassword') newPasswordComponent:NewPasswordComponent;

  constructor(private _profileService: ProfileService) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    swal.close();
  }

  private _passwordChangeSubscription: Subscription = null;
  changePassword(data : PasswordChangeData) {
    this._passwordChangeSubscription = this._profileService.changePassword(data.currentPassword, data.newPassword)
    .subscribe(_ => {
      swal('Ок', 'Пароль успешно изменён', 'success');
      },
      error => {
        switch (error as ProfileService.ChangePasswordError) {
          case "InvalidPasword":
            swal('Ошибка!', 'Текущий пароль введен неверно', 'error');
            break;
          default:
            swal('Ошибка!', 'При изменении пароля произошла ошибка', 'error');
        }
      },
      () => {
        this.newPasswordComponent.clearFileds();
      });
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/profile/profile.component.ts